import { createContext, useContext, useEffect, type ReactNode } from "react";
import type { SessaoAtual } from "@noesis/shared";
import { reconciliarComAConta } from "../tamanho-do-texto.js";

/**
 * A sessão do usuário, disponível em qualquer tela sem passar de mão em mão.
 *
 * Carrega também `limites`, que vem da configuração do servidor. É de lá que a
 * tela tira o `min` e o `max` do campo de meta: número de regra de negócio não
 * mora no componente (invariante 4).
 */

const Contexto = createContext<SessaoAtual | null>(null);

export function SessaoProvider({ sessao, children }: { sessao: SessaoAtual; children: ReactNode }) {
  /*
   * O tamanho do texto já foi aplicado no boot, com a última preferência deste
   * navegador — no boot ainda não se sabia quem entraria. Agora se sabe: se a
   * conta tem outra, ela vence, e a troca acontece uma vez só. Duas contas no
   * mesmo navegador deixam de herdar o ajuste uma da outra.
   */
  useEffect(() => {
    reconciliarComAConta(sessao.usuario.id);
  }, [sessao.usuario.id]);

  return <Contexto.Provider value={sessao}>{children}</Contexto.Provider>;
}

export function useSessao(): SessaoAtual {
  const s = useContext(Contexto);
  if (!s) throw new Error("useSessao fora do SessaoProvider.");
  return s;
}
